import { render, staticRenderFns } from "./enroll-club-add.vue?vue&type=template&id=0c0c8e6c&lang=pug"
import script from "./enroll-club-add.vue?vue&type=script&lang=js"
export * from "./enroll-club-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports